import { useIsTablet } from '../../hooks/useBreakpoint';
import MobileMenu from './MobileMenu';
import SideBar from './Sidebar';

export const Menu = () => {
	const isTablet = useIsTablet();
	return isTablet ? <MobileMenu /> : <SideBar />;
};
